import type { FC } from 'react';
import { extendAnalyticsData, useLineBehaviorV2 } from '@mwl/core-lib';
import StreamIcon from '@public/assets/sport/icons/stream.svg';
import { Button } from '@/components/Button/Button';
import { routes } from '@/constants';
import type { LineRowScoresProps } from '@/types';
import styles from './LineRowTranslation.module.scss';
export const LineRowTranslation: FC<LineRowScoresProps> = ({
  line,
  analytics
}) => {
  const {
    stage
  } = line;
  const {
    hasTranslation,
    lineHref
  } = useLineBehaviorV2({
    line,
    routes
  });
  if (!hasTranslation) {
    return null;
  }
  return <Button className={styles.widgets} as="link" href={lineHref} variant="text" analytics={extendAnalyticsData(analytics?.widgets, {
    href: lineHref,
    line_id: line.id
  })} data-sentry-element="Button" data-sentry-component="LineRowTranslation" data-sentry-source-file="LineRowTranslation.tsx">
      <div className={styles.widgetsIcons}>
        <StreamIcon className={cn(styles.indicatorIcon, {
        [styles.indicatorPregameIcon]: stage === 'PREGAME'
      })} data-sentry-element="StreamIcon" data-sentry-source-file="LineRowTranslation.tsx" />
      </div>
    </Button>;
};